export interface Translator {

   translate(...args: string[]): Promise<string> | string;
}
